<script>
    /**
     * This is a static pane that is modeless, and is docked to a window edge. It cannot be user
     * manipulated, and it applies padding to the document body, effectively offsetting everything
     * else including drawers. It is typically used for header and footer bars.
     */
    export default {
        name: 'ib-bar',

        props: {
            /**
             * Requested position relative to window [top, right, bottom, left, start, end].
             */
            position: {
                type: String,
                default: 'top'
            },
            /**
             * Shadow elevation (depth) [0-24].
             */
            elevation: Number,
            /**
             * Width in any CSS units.
             */
            width: String,
            /**
             * Height in any CSS units.
             */
            height: String,
            /**
             * Manually set z-index; default z-index is 1030.
             */
            zIndex: Number
        },

        computed: {
            actual() {
                const rtl = this.$rtl;
                return {
                    bottom: 'bottom',
                    left: 'left',
                    right: 'right',
                    start: rtl ? 'right' : 'left',
                    end: rtl ? 'left' : 'right'
                }[this.position] || 'top';
            },

            _class() {
                return {
                    ['_p'+this.actual]: true,
                    ['_e'+this.elevation]: this.elevation
                };
            }
        },

        beforeDestroy() {
            __app.registerOffset(this._uid);
        },

        render(h) {
            // vue-docgen-api
            if (0) {
                /**
                 * @slot All content goes in the default slot.
                 */
                const d = this.$slots.default;
            }

            const vm = this;
            const actual = vm.actual;

            return h('div', {
                'staticClass': '_bar',
                'class': this._class,
                'style': {
                    'width': this.width,
                    'height': this.height,
                    'zIndex': this.zIndex
                },
                'attrs': this.$attrs,
                'directives': [
                    {
                        name: 'size',
                        rawName: 'v-size',
                        value: this.resize,
                        expression: 'size',
                        modifiers: actual == 'top' || actual == 'bottom'
                            ? { height: true }
                            : { width: true }
                    }
                ]
            }, vm._t('default'));
        },

        methods: {
            resize(width, height) {
                const actual = this.actual;
                __app.registerOffset(this._uid, actual, actual == 'top' || actual == 'bottom' ? height : width);
            }
        }
    }
</script>

<style lang="less">
    @import "../../less/globals.less";

    ._bar {
        position: fixed;
        max-width: 100%;
        max-height: 100%;
        background-color: @bg-dialog;
        z-index: @z-bar;

        &._ptop {
            top: 0;
            left: 0;
            right: 0;
        }
        &._pbottom {
            bottom: 0;
            left: 0;
            right: 0;
        }
        &._pleft {
            left: 0;
            top: 0;
            bottom: 0;
        }
        &._pright {
            right: 0;
            top: 0;
            bottom: 0;
        }

        each(range(24), {
          &._e@{value} {
            .elevation(@value, -2px, .75);
          }
        });
    }
</style>

<ib-example id="bottom" name="Bottom Bar">
    <template lang="pug">
        include ../../icon/basic
        include ../../icon/messaging

        div
            ib-toggle(v-model="show") Show Bottom Bar
            ib-bar(v-if="show", id="ex-bottom", position="bottom", :elevation="3", class="inset-4 text-center")
                ib-button(appearance="clear", style="height:auto", class="inset-8 outsetx-16 icon-48")
                    +icon-basic-home
                ib-button(appearance="clear", style="height:auto", class="inset-8 outsetx-16 icon-48")
                    +icon-messaging-activity_grid
                ib-button(appearance="clear", style="height:auto", class="inset-8 outsetx-16 icon-48")
                    +icon-basic-settings
    </template>
    <script>
        {
            data() {
                return {
                    show: false
                };
            }
        }
    </script>
</ib-example>
